import { Box } from '@mui/material'
import React from 'react'

const NotFound = () => {
  return (
    <Box sx={{minHeight: "550px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center"}}>404 Not Found</Box>
  )
}

export default NotFound